import React from "react";
import { Sparkles } from "lucide-react";
import { BoxTray } from "@/components/bundle/BoxTray";
import { MiniGiftBox } from "@/components/MiniGiftBox";

const Burst = () => (
  <div className="pointer-events-none absolute inset-x-0 bottom-full h-0" data-testid="bundle-dream-burst">
    {Array.from({ length: 14 }).map((_, i) => (
      <span
        key={i}
        className="gg-gold-spark"
        style={{
          left: `${50 + (i % 2 ? 1 : -1) * ((i * 37) % 40)}%`,
          "--dx": `${(i % 2 ? 1 : -1) * (20 + ((i * 23) % 70))}px`,
          "--dy": `${-60 - ((i * 41) % 90)}px`,
          animationDelay: `${(i % 5) * 60}ms`,
        }}
      />
    ))}
    <p className="gg-burst-text absolute left-1/2 bottom-6 whitespace-nowrap font-serif italic text-plum text-[15px] px-4 py-1.5 rounded-full bg-cream/95 shadow-md">
      <MiniGiftBox size={20} className="inline-flex align-middle mr-1.5" />
      Dream Box unlocked — free gift is yours
    </p>
  </div>
);

export const BundleStickyBar = ({ active, pickedProducts, complete, savings, burst, onRemove, onAdd }) => {
  const left = active.qty - pickedProducts.length;
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[60] border-t"
      style={{
        background: "rgba(253,246,240,0.68)",
        backdropFilter: "blur(20px) saturate(150%)",
        WebkitBackdropFilter: "blur(20px) saturate(150%)",
        borderColor: "rgba(255,255,255,0.7)",
        boxShadow: "0 -14px 34px -14px rgba(74,44,53,0.3), inset 0 1px 0 rgba(255,255,255,0.8)",
      }}
      data-testid="bundle-sticky-bar"
    >
      {burst && <Burst />}
      <div className="max-w-[1200px] mx-auto px-4 sm:px-5 lg:px-10 pt-3 pb-3 relative flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
        {savings > 0 && (
          <div
            className="absolute -top-4 left-1/2 -translate-x-1/2 sm:left-auto sm:right-10 sm:translate-x-0 inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[10px] tracking-[0.24em] uppercase font-semibold text-plum gg-save-chip"
            style={{
              background: "linear-gradient(135deg,#FBEED6,#F4D58D)",
              boxShadow: "0 6px 16px -6px rgba(197,152,90,0.7), inset 0 0 0 1px rgba(197,152,90,0.5)",
            }}
            data-testid="bundle-save-chip"
          >
            <Sparkles size={11} className="text-gold" />
            Save ₹{savings.toLocaleString("en-IN")}
          </div>
        )}
        <div className="flex flex-col-reverse sm:flex-row items-start sm:items-center gap-2 sm:gap-5 min-w-0 sm:flex-1">
          <BoxTray active={active} pickedProducts={pickedProducts} onRemove={onRemove} complete={complete} />
          <p className="text-[10px] sm:text-[11px] tracking-[0.2em] uppercase font-semibold text-plum leading-snug whitespace-nowrap" data-testid="bundle-bar-status">
            {complete ? (
              <>
                {active.name} ready
                <span className="sm:block text-plum/60"> · ₹{active.price}{active.hasFreeGift ? " + Free Gift" : ""}</span>
              </>
            ) : (
              <>
                Pick {left} more
                <span className="sm:block text-plum/60"> · {active.qty} for ₹{active.price}</span>
              </>
            )}
          </p>
        </div>
        <button
          onClick={onAdd}
          disabled={!complete}
          data-testid="bundle-add-cta"
          className="w-full sm:w-auto flex-shrink-0 px-8 py-3.5 sm:py-3 rounded-full text-[11px] tracking-[0.28em] uppercase font-semibold text-cream disabled:opacity-60 disabled:cursor-not-allowed transition-transform hover:-translate-y-0.5 active:scale-[0.98]"
          style={{ background: "linear-gradient(135deg,#4A2C35,#6B3E4C)", boxShadow: "0 10px 24px -10px rgba(74,44,53,0.6)" }}
        >
          {complete ? `Add Bundle · ₹${active.price}` : `${pickedProducts.length}/${active.qty} Picked`}
        </button>
      </div>
    </div>
  );
};

export default BundleStickyBar;
